<template>
        <div ref="risktype" class="pbr-index-chart">
<Empty></Empty>
                        </div>
</template>

<script>
import * as echarts from 'echarts'
import emitter from 'element-ui/src/mixins/emitter'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartRiskType',
  mixins: [emitter, Mixin],
  inject: ['chartDatas'],
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    height: { type: Number }
  },
  data () {
    return {
      risktypeDom: null,
      riskTypeChart: null,
      optionRisktype: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const riskChartData = this.chartDatas.riskChartData()
      // return riskChartData.riskTypeChart || [{}]
      if (riskChartData.hasOwnProperty('riskTypeChart') && riskChartData.riskTypeChart.length > 0) {
        return riskChartData.riskTypeChart
      }
      return [{id: '', name: '', num: 0, percent: 0}]
    }
  },
  methods: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.risktype){
        return
      }
      if (this.riskTypeChart) {
        this.riskTypeChart.dispose()
      }
      let countContrastDom = this.$refs.risktype
      this.riskTypeChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5})
      this.riskTypeChart.setOption(this.optionRisktype)
      this.riskTypeChart.on('click', function (param) {
        self.dispatch('pbrIndex', 'filterData', {module: 'fx', condition: {type: 'category', title: param.data.name, id: param.data.id}})
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.riskTypeChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      let self = this
      this.optionRisktype = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.risk.distribution'),
          left: 'center',
          top:0
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          formatter: function (a) {
            let listItem = `${a.seriesName}<br /><i style="display: inline-block;width: 10px;height: 10px;background: ${a.color};margin-right: 5px;border-radius: 50%;}"></i>
                            ${a.value.name}<br/><p style="padding-left:20px;">${self.$t('charts.home.risk.number')}：${a.value.num}</br>${self.$t('charts.home.opportunity.percentage')} ：${a.percent}%</p>`

            return '<div class="">' + listItem + '</div>'
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        legend: {
          type:'scroll',
          orient: 'horizontal',
          top: this.showTitle ? 20 : 0,
          itemWidth:10,
          itemHeight:10,
          textStyle: {
            color: self.isDark() ?  '#ebedee' : '#101010'
          },
          tooltip: {
            show: true,
            // position: ['50%', '50%'],
            // position: function (p) { // 其中p为当前鼠标的位置
            //   return [p[0] + 10, p[1] - 10]
            // },
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
          },
        },
        dataset: {
          dimensions: ['id', 'num', 'name', 'percent'],
          source: this.chartData
        },

        series: [
          {
            name: this.$t('charts.home.risk.distribution'),
            type: 'pie',
            radius: '100%',
            top: this.showTitle ? 50 : 30,
            bottom:10,
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
            //   show: false,
              normal: {
                // formatter: '{@percent}',
                formatter:'{d}%',
                position: 'inside',
                fontSize: 8,
                color: '#fff',
                align: 'center',
                verticalAlign: 'middle'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
          }
        ]
      }
    },
    resize () {
      this.isResize = true
      this.riskTypeChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.riskTypeChart) {
            this.riskTypeChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
